import React, { memo } from 'react'

import CustomCheckbox from '../inputs/CustomCheckbox'

const OptionalCheckbox = ({
  dispatchAction,
  error,
  checkbox,
  description,
  dispatchCheckbox
}) => {
  return (
    <CustomCheckbox
      label={description}
      checked={checkbox}
      onChange={() => dispatchAction(dispatchCheckbox, !checkbox)}
      error={error[dispatchCheckbox]}
    />
  )
}

export default memo(OptionalCheckbox)
